import React from "react";

type RenderWordSearchProps = {
  table: string[][];
  selectedCells: Set<string>;
  wordNumbers: Map<string, number>;
  toggleCell: (row: number, col: number) => void;
};

const RenderWordSearch: React.FC<RenderWordSearchProps> = ({
  table,
  selectedCells,
  wordNumbers,
  toggleCell,
}) => {
  const rows = table.length + 2;
  const columns = table[0].length + 2;

  const isTableCell = (row: number, col: number) => {
    return (
      row >= 0 &&
      row < table.length &&
      col >= 0 &&
      col < table[0].length
    );
  };

  return (
    <div
      className="word-search"
      style={{
        gridTemplateColumns: `repeat(${columns}, 3vw)`,
        gridTemplateRows: `repeat(${rows}, 3vw)`,
      }}
    >
      {Array.from({ length: rows * columns }, (_, index) => {
        const gridRow = Math.floor(index / columns);
        const gridCol = index % columns;

        const row = gridRow - 1;
        const col = gridCol - 1;

        // Основная таблица
        if (isTableCell(row, col)) {
          const key = `${row}-${col}`;
          const isSelected = selectedCells.has(key);

          return (
            <div
              key={`${gridRow}-${gridCol}`}
              className={`word-search-cell ${
                isSelected ? "word-search-cell--selected" : ""
              }`}
              onClick={() => toggleCell(row, col)}
            >
              {table[row][col]}
            </div>
          );
        }

        // Дополнительная область для номеров
        const number = wordNumbers.get(`${row}-${col}`);

        return (
          <div
            key={`${gridRow}-${gridCol}`}
            className={`word-search-number ${
              number !== undefined
                ? "word-search-number--has-number"
                : ""
            }`}
          >
            {number}
          </div>
        );
      })}
    </div>
  );
};

export default RenderWordSearch;